export default __webpack_public_path__ + "static/kids-f844e56deb8ea31c4e70c279f57dedab.png";